import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { CoreServiceRegistry } from '../../../../core/core-service-registry';
import { SharedServiceRegistry } from '../../../../shared/shared-service-registry';
import { SimpleEntityActionService } from '../../../../shared/services/searchable-entity/simple-entity/simple-entity-action.service';
import { PrinterSetupService } from 'sce-home';
@Injectable()
export class ViewMyPrintJobsActionService extends SimpleEntityActionService {

  public showSearchFilterPopup = false;

  constructor(protected coreServiceRegistry: CoreServiceRegistry,
    protected sharedServiceRegistry: SharedServiceRegistry,
    private printerSetupService: PrinterSetupService) {
    super(coreServiceRegistry, sharedServiceRegistry);
  }

  public printSelectedJobs(): any {
    const payload: Array<any> = [];
    // LFWM-3191-adding tableId
    const tableId = this.dataService.searchParams.tableId;
    this.dataService.searchService.getPagedData().pageRows
      .filter((pageRow: any) => {
        return pageRow.isSelected;
      })
      .forEach((pageRow: any) => {
        const printJob: any = {};
        printJob['jobId'] = pageRow.cells.jobId['cVal'];
        printJob['submittedBy'] = pageRow.cells.owner['cVal'];
        printJob['tableId'] = tableId;
        payload.push(printJob);
      });
    if (payload.length > 0) {
      this.coreServiceRegistry.http$.post('api/core/reprintJobs/', JSON.stringify(payload))
        .map((response: any) => {
          return response;
        })
        .catch((error: any) => {
          return Observable.throw(this.resourceService.get('msg_fail_reprint') + this.resourceService.get(error.message));
        })
        .subscribe((data: any) => {
          this.alertService.success(this.resourceService.get('msg_prnt_success'));
          this.dataService.searchService.performSearch();
        });
    } else {
      this.alertService.clearAll().success(this.resourceService.get('msg_prnt_val'));
    }
  }
  // printPreviewJobs
  public printPreviewJobs(): any {
    // 0 -> not available  jobStatus
    // 6-> in progress
    // 9-> available
    if (this.dataService.searchService.getPagedData().pageRows.length === 0) {
      this.alertService.clearAll().error(this.resourceService.get('msg_no_detail'));
      return;
    } else if (this.dataService.searchService.getSelectedRows().length === 0) {
      this.alertService.clearAll().error(this.resourceService.get('msg_sel_detail'));
      return;
    } else if (this.dataService.searchService.getSelectedRows().length > 1) {
      this.alertService.clearAll().error(this.resourceService.get('msg_multiple_entries'));
      return;
    } else if (this.dataService.searchService.getSelectedRows()[0].cells['jobStatus'].cVal === '6') {
      this.alertService.clearAll().error(this.resourceService.get('msg_print_preview_inprogress'));
      return;
    } else if (this.dataService.searchService.getSelectedRows()[0].cells['pdfpreview'].cVal === 'N' ||
      this.dataService.searchService.getSelectedRows()[0].cells['jobStatus'].cVal !== '9') {
      this.alertService.clearAll().error(this.resourceService.get('msg_print_preview_unavailable'));
      return;
    } else {
      let jobId = this.dataService.searchService.getSelectedRows()[0].cells['jobId'].cVal;
      this.printerSetupService.toPreviewInNewTab(jobId).subscribe(resp => {
        let blobURL = URL.createObjectURL(resp);
        window.open(blobURL);
      }, (error) => {
        this.alertService.clearAll().error(this.resourceService.translateServerResponse(error));
      });
    }

  }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/reports/view-my-print-jobs/services/view-my-print-jobs-action.service.ts